// extracted by mini-css-extract-plugin
export default {"report-content__description":"ReportContent_report-content__description__nT-Fx","signedView":"ReportContent_signedView__I37ki","signedBtn":"ReportContent_signedBtn__FkaYA"};